import { useEffect, useState } from "react";
import NavigationTabs from "../../../../utils/components/NavigationTabs";
import Modal from "../../../../utils/components/Modal";
import Options from "./components/Options";
import GeneralInformation from "./components/GeneralInformation";
const ProgressSettings = ({
  translate,
  workflowTemplateData,
  isProgressSettingsModalOpen,
  onModalClose,
  handlePositiveButtonClick,
}) => {
  const [activeTab, setActiveTab] = useState(
    translate(
      "design_approval_process.uppercase_translates.general-informations"
    )
  );
  const [progressSettings, setProgressSettings] = useState({});

  useEffect(() => {
    let workflowData = Object.assign({}, workflowTemplateData);
    workflowData.workflow_type = workflowData.workflow_type || "manual";

    setProgressSettings(workflowData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProgressSettingsModalOpen]);

  return (
    <div>
      <Modal
        title={translate(
          "design_approval_process.progress-settings-modal.progress-settings"
        )}
        positiveButtonNode={translate("save")}
        negativeButtonNode={translate("cancel")}
        positiveButtonHandler={() =>
          handlePositiveButtonClick(progressSettings)
        }
        modalSize="lg"
        show={isProgressSettingsModalOpen}
        setShow={() => onModalClose()}
      >
        <div className="border-bottom mb-4">
          {/** Dinamikleştirelecek Alan */}
          <NavigationTabs
            tabs={[
              translate(
                "design_approval_process.uppercase_translates.general-informations"
              ),
              translate("design_approval_process.uppercase_translates.options"),
            ]}
            activeTab={activeTab}
            onTabClick={(tab) => setActiveTab(tab)}
          />
          {/** Dinamikleştirelecek Alan */}
        </div>
        {activeTab ===
          translate(
            "design_approval_process.uppercase_translates.general-informations"
          ) && (
          <GeneralInformation
            name={progressSettings.name}
            status={progressSettings.status}
            createdAt={progressSettings.created_at}
            createdBy={progressSettings.created_by}
            modifiedAt={progressSettings.modified_at}
            modifiedBy={progressSettings.modified_by}
            version={progressSettings.version}
            id={progressSettings.id}
            handleAction={(data) =>
              setProgressSettings({
                ...progressSettings,
                ...data,
              })
            }
            translate={translate}
          />
        )}
        {activeTab ===
          translate("design_approval_process.uppercase_translates.options") && (
          <Options
            workflowType={progressSettings.workflow_type}
            autoFormTemplateId={progressSettings.auto_form_template_id}
            autoRepeatCycle={progressSettings.auto_repeat_cycle}
            autoRepeatCycleValues={progressSettings.auto_repeat_cycle_values}
            autoRepeatTime={progressSettings.auto_repeat_time}
            setProgressSettings={setProgressSettings}
            site_set_path={progressSettings.site_set_path}
            site_set_path_ids={progressSettings.site_set_path_ids}
            progressSettings={progressSettings}
            handleAction={(data) =>
              setProgressSettings({
                ...progressSettings,
                ...data,
              })
            }
            translate={translate}
          />
        )}
      </Modal>
    </div>
  );
};
export default ProgressSettings;
